import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function TTNumberIcon({ className }: IconProps) {
  return (
    <svg
      width="75"
      height="75"
      viewBox="0 0 75 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_751)">
        <path
          d="M51.1338 59.373H23.8652V70.2982H51.1338V59.373Z"
          fill="#EAEDF8"
        />
        <path
          d="M70.8938 61.44H4.08348C1.81488 61.44 0 59.6002 0 57.3516V4.08843C0 1.83979 1.83757 0 4.08348 0H70.8938C73.1624 0 74.9773 1.83979 74.9773 4.08843V57.3289C74.9773 59.6002 73.1397 61.4173 70.8938 61.4173"
          fill="#EAEDF8"
        />
        <path
          d="M67.8311 50.8556H7.1687C6.03439 50.8556 5.12695 49.9471 5.12695 48.8114V7.15481C5.12695 6.01914 6.03439 5.1106 7.1687 5.1106H67.8538C68.9881 5.1106 69.8956 6.01914 69.8956 7.15481V48.7887C69.8956 49.9243 68.9881 50.8329 67.8538 50.8329"
          fill="white"
        />
        <path
          d="M62.3866 75.0001H12.6135C11.2977 75.0001 10.2314 73.9325 10.2314 72.6151C10.2314 71.2978 11.2977 70.2302 12.6135 70.2302H62.3866C63.7024 70.2302 64.7686 71.2978 64.7686 72.6151C64.7686 73.9325 63.7024 75.0001 62.3866 75.0001Z"
          fill="#EAEDF8"
        />
        <path
          d="M36.819 11.2659H21.1429C20.5758 11.2659 20.1221 10.8116 20.1221 10.2438C20.1221 9.67595 20.5758 9.22168 21.1429 9.22168H36.819C37.3861 9.22168 37.8399 9.67595 37.8399 10.2438C37.8399 10.8116 37.3861 11.2659 36.819 11.2659Z"
          fill="#00C4B3"
        />
        <path
          d="M44.6458 29.0052H29.9906C29.4234 29.0052 28.9697 28.5509 28.9697 27.983C28.9697 27.4152 29.4234 26.9609 29.9906 26.9609H44.6458C45.2129 26.9609 45.6666 27.4152 45.6666 27.983C45.6666 28.5509 45.2129 29.0052 44.6458 29.0052Z"
          fill="#00C4B3"
        />
        <path
          d="M29.9907 24.576H21.1205C20.5533 24.576 20.0996 24.1217 20.0996 23.5538C20.0996 22.986 20.5533 22.5317 21.1205 22.5317H29.9907C30.5579 22.5317 31.0116 22.986 31.0116 23.5538C31.0116 24.1217 30.5579 24.576 29.9907 24.576Z"
          fill="#00C4B3"
        />
        <path
          d="M40.2219 37.886H21.1429C20.5758 37.886 20.1221 37.4317 20.1221 36.8639C20.1221 36.2961 20.5758 35.8418 21.1429 35.8418H40.2219C40.789 35.8418 41.2428 36.2961 41.2428 36.8639C41.2428 37.4317 40.789 37.886 40.2219 37.886Z"
          fill="#00C4B3"
        />
        <path
          d="M30.331 42.3152H21.1205C20.5533 42.3152 20.0996 41.8609 20.0996 41.2931C20.0996 40.7253 20.5533 40.271 21.1205 40.271H30.331C30.8982 40.271 31.3519 40.7253 31.3519 41.2931C31.3519 41.8609 30.8982 42.3152 30.331 42.3152Z"
          fill="#00C4B3"
        />
        <path
          d="M46.0304 15.6951H30.014C29.4469 15.6951 28.9932 15.2408 28.9932 14.673C28.9932 14.1051 29.4469 13.6509 30.014 13.6509H46.0304C46.5975 13.6509 47.0512 14.1051 47.0512 14.673C47.0512 15.2408 46.5975 15.6951 46.0304 15.6951Z"
          fill="#00416B"
        />
        <path
          d="M37.4997 33.4344H29.9906C29.4234 33.4344 28.9697 32.9801 28.9697 32.4122C28.9697 31.8444 29.4234 31.3901 29.9906 31.3901H37.4997C38.0668 31.3901 38.5205 31.8444 38.5205 32.4122C38.5205 32.9801 38.0668 33.4344 37.4997 33.4344Z"
          fill="#00416B"
        />
        <path
          d="M39.8817 46.7444H29.9906C29.4234 46.7444 28.9697 46.2901 28.9697 45.7223C28.9697 45.1545 29.4234 44.7002 29.9906 44.7002H39.8817C40.4489 44.7002 40.9026 45.1545 40.9026 45.7223C40.9026 46.2901 40.4489 46.7444 39.8817 46.7444Z"
          fill="#00416B"
        />
        <path
          d="M52.8356 37.886H45.3265C44.7594 37.886 44.3057 37.4317 44.3057 36.8639C44.3057 36.2961 44.7594 35.8418 45.3265 35.8418H52.8356C53.4028 35.8418 53.8565 36.2961 53.8565 36.8639C53.8565 37.4317 53.4028 37.886 52.8356 37.886Z"
          fill="#00416B"
        />
        <path
          d="M46.0301 42.3152H35.4584C34.8912 42.3152 34.4375 41.8609 34.4375 41.2931C34.4375 40.7253 34.8912 40.271 35.4584 40.271H46.0301C46.5972 40.271 47.0509 40.7253 47.0509 41.2931C47.0509 41.8609 46.5972 42.3152 46.0301 42.3152Z"
          fill="#00416B"
        />
        <path
          d="M37.4997 20.124H29.9906C29.4234 20.124 28.9697 19.6698 28.9697 19.1019C28.9697 18.5341 29.4234 18.0798 29.9906 18.0798H37.4997C38.0668 18.0798 38.5205 18.5341 38.5205 19.1019C38.5205 19.6698 38.0668 20.124 37.4997 20.124Z"
          fill="#00416B"
        />
        <path
          d="M60.3445 29.0052H49.7728C49.2057 29.0052 48.752 28.5509 48.752 27.983C48.752 27.4152 49.2057 26.9609 49.7728 26.9609H60.3445C60.9117 26.9609 61.3654 27.4152 61.3654 27.983C61.3654 28.5509 60.9117 29.0052 60.3445 29.0052Z"
          fill="#00416B"
        />
        <path
          d="M62.3864 15.6951H51.1342C50.567 15.6951 50.1133 15.2408 50.1133 14.673C50.1133 14.1051 50.567 13.6509 51.1342 13.6509H62.3864C62.9536 13.6509 63.4073 14.1051 63.4073 14.673C63.4073 15.2408 62.9536 15.6951 62.3864 15.6951Z"
          fill="#EAEDF8"
        />
        <path
          d="M55.5576 20.124H42.6039C42.0367 20.124 41.583 19.6698 41.583 19.1019C41.583 18.5341 42.0367 18.0798 42.6039 18.0798H55.5576C56.1247 18.0798 56.5785 18.5341 56.5785 19.1019C56.5785 19.6698 56.1247 20.124 55.5576 20.124Z"
          fill="#EAEDF8"
        />
        <path
          d="M57.259 33.4344H42.6039C42.0367 33.4344 41.583 32.9801 41.583 32.4122C41.583 31.8444 42.0367 31.3901 42.6039 31.3901H57.259C57.8262 31.3901 58.2799 31.8444 58.2799 32.4122C58.2799 32.9801 57.8262 33.4344 57.259 33.4344Z"
          fill="#EAEDF8"
        />
        <path
          d="M56.239 46.7444H44.9867C44.4195 46.7444 43.9658 46.2901 43.9658 45.7223C43.9658 45.1545 44.4195 44.7002 44.9867 44.7002H56.239C56.8061 44.7002 57.2598 45.1545 57.2598 45.7223C57.2598 46.2901 56.8061 46.7444 56.239 46.7444Z"
          fill="#EAEDF8"
        />
        <path
          d="M62.0461 42.3152H51.1342C50.567 42.3152 50.1133 41.8609 50.1133 41.2931C50.1133 40.7253 50.567 40.271 51.1342 40.271H62.0461C62.6133 40.271 63.067 40.7253 63.067 41.2931C63.067 41.8609 62.6133 42.3152 62.0461 42.3152Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 11.2659H12.6136C12.0465 11.2659 11.5928 10.8116 11.5928 10.2438C11.5928 9.67595 12.0465 9.22168 12.6136 9.22168H16.0165C16.5837 9.22168 17.0374 9.67595 17.0374 10.2438C17.0374 10.8116 16.5837 11.2659 16.0165 11.2659Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 15.6951H12.6136C12.0465 15.6951 11.5928 15.2408 11.5928 14.673C11.5928 14.1051 12.0465 13.6509 12.6136 13.6509H16.0165C16.5837 13.6509 17.0374 14.1051 17.0374 14.673C17.0374 15.2408 16.5837 15.6951 16.0165 15.6951Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 20.124H12.6136C12.0465 20.124 11.5928 19.6698 11.5928 19.1019C11.5928 18.5341 12.0465 18.0798 12.6136 18.0798H16.0165C16.5837 18.0798 17.0374 18.5341 17.0374 19.1019C17.0374 19.6698 16.5837 20.124 16.0165 20.124Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 24.576H12.6136C12.0465 24.576 11.5928 24.1217 11.5928 23.5538C11.5928 22.986 12.0465 22.5317 12.6136 22.5317H16.0165C16.5837 22.5317 17.0374 22.986 17.0374 23.5538C17.0374 24.1217 16.5837 24.576 16.0165 24.576Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 29.0052H12.6136C12.0465 29.0052 11.5928 28.5509 11.5928 27.983C11.5928 27.4152 12.0465 26.9609 12.6136 26.9609H16.0165C16.5837 26.9609 17.0374 27.4152 17.0374 27.983C17.0374 28.5509 16.5837 29.0052 16.0165 29.0052Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 33.4344H12.6136C12.0465 33.4344 11.5928 32.9801 11.5928 32.4122C11.5928 31.8444 12.0465 31.3901 12.6136 31.3901H16.0165C16.5837 31.3901 17.0374 31.8444 17.0374 32.4122C17.0374 32.9801 16.5837 33.4344 16.0165 33.4344Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 37.886H12.6136C12.0465 37.886 11.5928 37.4317 11.5928 36.8639C11.5928 36.2961 12.0465 35.8418 12.6136 35.8418H16.0165C16.5837 35.8418 17.0374 36.2961 17.0374 36.8639C17.0374 37.4317 16.5837 37.886 16.0165 37.886Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 42.3152H12.6136C12.0465 42.3152 11.5928 41.8609 11.5928 41.2931C11.5928 40.7253 12.0465 40.271 12.6136 40.271H16.0165C16.5837 40.271 17.0374 40.7253 17.0374 41.2931C17.0374 41.8609 16.5837 42.3152 16.0165 42.3152Z"
          fill="#EAEDF8"
        />
        <path
          d="M16.0165 46.7444H12.6136C12.0465 46.7444 11.5928 46.2901 11.5928 45.7223C11.5928 45.1545 12.0465 44.7002 12.6136 44.7002H16.0165C16.5837 44.7002 17.0374 45.1545 17.0374 45.7223C17.0374 46.2901 16.5837 46.7444 16.0165 46.7444Z"
          fill="#EAEDF8"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_751">
          <rect width="75" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
